import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { PreviewToolbar } from "@/components/articles/preview/preview-toolbar";
import { SharePreviewIframe } from "@/components/articles/preview/share-preview-iframe";
import { FullscreenPreview } from "@/components/articles/preview/fullscreen-preview";
import type { PreviewMode, PreviewData } from "@/components/articles/preview/preview-html-builder";
import type { PremiumArticleMetaFormValues } from "@/lib/validation/article-schema";

interface PreviewPanelProps {
  fullContentHtml: string;
  freeContentHtml: string;
}

export function PreviewPanel({ fullContentHtml, freeContentHtml }: PreviewPanelProps) {
  const [mode, setMode] = useState<PreviewMode>("public");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { watch } = useFormContext<PremiumArticleMetaFormValues>();

  const formValues = watch();

  const previewData: PreviewData = {
    mode,
    title: formValues.title?.ko || "",
    authorName: formValues.authorInfo?.name?.ko || "",
    authorProfileImageURL: formValues.authorInfo?.profileImageURL?.ko || undefined,
    authorBiography: formValues.authorInfo?.biography?.ko || undefined,
    authorSocialAccounts: formValues.authorInfo?.socialAccounts
      ?.filter((a) => a.platformName && a.link?.ko)
      .map((a) => ({ platformName: a.platformName, link: a.link.ko })),
    thumbnailUrl: formValues.thumbnail?.url?.ko || undefined,
    thumbnailAlt: formValues.thumbnail?.alt?.ko || undefined,
    freeContentHtml,
    fullContentHtml,
  };

  return (
    <div className="flex h-full flex-col">
      <PreviewToolbar mode={mode} onModeChange={setMode} onToggleFullscreen={() => setIsFullscreen(true)} />

      <div className="flex-1 overflow-hidden">
        <SharePreviewIframe previewData={previewData} />
      </div>

      {isFullscreen && (
        <FullscreenPreview previewData={previewData} initialMode={mode} onClose={() => setIsFullscreen(false)} />
      )}
    </div>
  );
}
